// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"wrapper_mainWrapper__3RBAW","thrasherPreventer":"wrapper_thrasherPreventer__RI7n0"};